// extracted by mini-css-extract-plugin
export default {"layer-selector":"styles_layer-selector__IgFtR","active":"styles_active__DA7ZD","index":"styles_index__zXA0C","name":"styles_name__vl32i","delete":"styles_delete__w1L1y"};